import { motion } from "framer-motion";

// Masked line-by-line reveal for hero / headings.
export function RevealLines({ lines, className = "", delay = 0, stroke = false }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, delay: delay + i * 0.12, ease: [0.16, 1, 0.3, 1] }}
          >
            <span className={stroke ? "text-stroke-accent" : ""}>{line}</span>
          </motion.span>
        </span>
      ))}
    </span>
  );
}

// Scroll-triggered fade-up wrapper.
export function FadeUp({ children, className = "", delay = 0, y = 40 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}
